export default __webpack_public_path__ + "static/media/grade-config.d1cb2598.md";